import type {Channel} from '@mattermost/types/channels';

/**
 * Определяет является ли канал архивированным
 */
export function isChannelArchived(channel?: Channel) {
    return Boolean(channel && channel.delete_at !== 0);
}
